import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export function PersonalInfoCardSkeleton(): React.ReactElement {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderRadius: '16px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        px: '16px',
        py: '14px',
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack spacing="4px">
          <Skeleton variant="text" width={140} height={20} animation="wave" />
          <Skeleton variant="text" width={100} height={16} animation="wave" />
        </Stack>
        <Skeleton variant="rounded" width={52} height={32} animation="wave" />
      </Stack>
    </Box>
  );
}
